<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6667 16.668C11.6667 17.5885 10.9205 18.3346 10 18.3346C9.0795 18.3346 8.33333 17.5885 8.33333 16.668C8.33333 16.1702 8.55158 15.7234 8.89758 15.418H8.54167C7.73625 15.418 7.08333 14.7651 7.08333 13.9596C7.08333 13.4641 7.33052 13.0262 7.70833 12.7627V5.0013H6.66667C5.88099 5.0013 5.48816 5.0013 5.24408 4.75723C5 4.51314 5 4.12031 5 3.33464C5 2.54896 5 2.15613 5.24408 1.91204C5.48816 1.66797 5.88099 1.66797 6.66667 1.66797H13.3333C14.119 1.66797 14.5118 1.66797 14.7559 1.91204C15 2.15613 15 2.54896 15 3.33464C15 4.12031 15 4.51314 14.7559 4.75723C14.5118 5.0013 14.119 5.0013 13.3333 5.0013H12.2917V12.7627C12.6695 13.0262 12.9167 13.4641 12.9167 13.9596C12.9167 14.7651 12.2637 15.418 11.4583 15.418H11.1024C11.4484 15.7234 11.6667 16.1702 11.6667 16.668ZM11.0417 5.0013H8.95833V12.5013H11.0417V5.0013Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.06178 6.51654C6.14549 6.18166 6.48483 5.97806 6.8197 6.06178L13.4864 7.72844C13.8212 7.81216 14.0248 8.15149 13.9411 8.48639C13.8574 8.82122 13.5181 9.0248 13.1832 8.94114L6.51654 7.27445C6.18166 7.19074 5.97806 6.8514 6.06178 6.51654ZM6.06178 9.43322C6.14549 9.0983 6.48483 8.89472 6.8197 8.97847L13.4864 10.6451C13.8212 10.7288 14.0248 11.0681 13.9411 11.4031C13.8574 11.7379 13.5181 11.9415 13.1832 11.8578L6.51654 10.1911C6.18166 10.1074 5.97806 9.76805 6.06178 9.43322Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.9275 6.22828C17.1703 6.4736 17.1683 6.86931 16.923 7.11215L16.3337 7.69545C16.0884 7.93829 15.6927 7.93628 15.4499 7.69096C15.2071 7.44565 15.2091 7.04993 15.4544 6.8071L16.0436 6.22379C16.2889 5.98095 16.6846 5.98296 16.9275 6.22828ZM3.07513 6.22828C3.31796 5.98296 3.71369 5.98095 3.95899 6.22379L4.54825 6.8071C4.79357 7.04993 4.79558 7.44565 4.55274 7.69096C4.3099 7.93628 3.91419 7.93829 3.66887 7.69545L3.07961 7.11215C2.8343 6.86931 2.83229 6.4736 3.07513 6.22828ZM18.3346 10.2092H16.668C16.3228 10.2092 16.043 9.92939 16.043 9.58422C16.043 9.23905 16.3228 8.95922 16.668 8.95922H18.3346C18.6798 8.95922 18.9596 9.23905 18.9596 9.58422C18.9596 9.92939 18.6798 10.2092 18.3346 10.2092ZM1.04297 9.58505C1.04297 9.23989 1.32279 8.96005 1.66797 8.96005H3.33464C3.67981 8.96005 3.95964 9.23989 3.95964 9.58505C3.95964 9.93022 3.67981 10.2101 3.33464 10.2101H1.66797C1.32279 10.2101 1.04297 9.93022 1.04297 9.58505ZM4.55274 11.4783C4.79558 11.7236 4.79357 12.1193 4.54825 12.3622L3.95899 12.9455C3.71369 13.1883 3.31796 13.1863 3.07513 12.941C2.83229 12.6957 2.8343 12.3 3.07961 12.0571L3.66887 11.4738C3.91419 11.231 4.3099 11.233 4.55274 11.4783ZM15.4499 11.4783C15.6927 11.233 16.0884 11.231 16.3337 11.4738L16.923 12.0571C17.1683 12.3 17.1703 12.6957 16.9275 12.941C16.6846 13.1863 16.2889 13.1883 16.0436 12.9455L15.4544 12.3622C15.2091 12.1194 15.2071 11.7236 15.4499 11.4783Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AdminToolsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>